import { ReactComponent as On } from '../../../../assets/icons/on.svg';
import { ReactComponent as Off } from '../../../../assets/icons/off.svg';
import Row from '../box/row';
import styled, { useTheme } from 'styled-components';
import SizedBox from '../box/sizedBox';
import { LXbody } from '../../texts/lxText';
import Column from '../box/column';

interface LXTwoRadioProps<T> {
  value: T;
  values: T[];
  labels: string[];
  width: string;
  onSelect: (val: T) => void;
  tabIndex?: number;
}

interface RadioContainerProps {
  isSelected: boolean;
}

const RadioContainer = styled.div<RadioContainerProps>`
  height: 48px;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 15px;
  border: ${(props) =>
    `1px solid ${
      props.isSelected
        ? props.theme.colors.primary500
        : props.theme.colors.grayLine
    }`};
  background-color: ${(props) =>
    props.isSelected ? props.theme.colors.primaryBg : null};
  border-radius: 12px;
  cursor: pointer;
`;

const LXTwoRadio = <T,>(props: LXTwoRadioProps<T>) => {
  const theme = useTheme();

  const buildIcon = (isSelect: boolean) => {
    if (isSelect) {
      return <On></On>;
    } else {
      return <Off></Off>;
    }
  };

  const buildItems = () => {
    return props.labels.map((label, idx) => {
      const nowValue = props.values[idx];
      const isSelect = nowValue === props.value;
      const tabIndex =
        props.tabIndex === undefined ? undefined : props.tabIndex + idx;
      if (idx === 0) {
        return (
          <RadioContainer
            key={idx}
            onClick={() => props.onSelect(nowValue)}
            isSelected={isSelect}
            tabIndex={tabIndex}
          >
            <Row
              alignItems="center"
              justifyContent="space-between"
              flexGrow={1}
            >
              <LXbody color={theme.colors.title}>{label}</LXbody>
              {buildIcon(isSelect)}
            </Row>
          </RadioContainer>
        );
      } else {
        return (
          <Row key={idx} flexGrow={1}>
            <SizedBox width={8}></SizedBox>
            <RadioContainer
              onClick={() => props.onSelect(nowValue)}
              isSelected={isSelect}
              tabIndex={tabIndex}
            >
              <Row
                alignItems="center"
                justifyContent="space-between"
                flexGrow={1}
              >
                <LXbody color={theme.colors.title}>{label}</LXbody>
                {buildIcon(isSelect)}
              </Row>
            </RadioContainer>
          </Row>
        );
      }
    });
  };

  return <Row width={props.width}>{buildItems()}</Row>;
};

export default LXTwoRadio;

interface LXLabelTwoRadioProps {
  label: string;
}

export const LXLabelTwoRadio = <T,>(
  props: LXLabelTwoRadioProps & LXTwoRadioProps<T>
) => {
  const theme = useTheme();

  return (
    <Column>
      <LXbody color={theme.colors.title}>{props.label}</LXbody>
      <SizedBox height={8}></SizedBox>
      <LXTwoRadio {...props}></LXTwoRadio>
    </Column>
  );
};
